<template>
    <div>
        <div class="card w-100 animated fadeInUp faster">
            <div class="card-header">
                <div class="row align-items-center">
                    <div class="col-auto"><i class="fal fa-shopping-basket text-primary fa-2x"></i></div>
                    <div class="col pl-0">
                        <h5 class="mb-0 font-weight-normal">
                            {{ basket.recurring ? $t("basket.header_subscription") : $t("basket.header_order") }}</h5>
                    </div>
                    <div class="d-block d-lg-none col-4 text-right">
                        <a data-toggle="collapse" href="#collapseOrder" role="button" aria-expanded="false" aria-controls="collapseOrder" class="d-inline-block d-lg-none btn btn-primary btn-sm collapsed">
                            {{ $t("basket.buttons.show") }}
                        </a>
                    </div>
                </div>
            </div>
            <div class="collapse d-lg-block" id="collapseOrder">
                <div class="card-body p-0">
                    <div class="table-responsive pt-2 pb-0 mb-0">
                        <table class="table small mb-0 table-cart">
                            <thead class="thead-light">
                                <tr>
                                    <th>{{ $t("basket.table.item") }}</th>
                                    <th>{{ $t("basket.table.price") }}</th>
                                    <th class="text-right">{{ $t("basket.table.quantity") }}</th>
                                    <th class="text-right">{{ $t("basket.table.total") }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="row-product" v-for="item in items">
                                    <td>{{ item.name }}</td>
                                    <td v-if="item.price == item.initialprice">
                                        {{ basket.price.currencySymbol }}
                                        {{ item.price.toFixed(2) }}
                                    </td>
                                    <td v-if="item.price != item.initialprice">
                                        <span class="text-strikethrough">
                                            {{ basket.price.currencySymbol }}
                                            {{ item.initialprice.toFixed(2) }}
                                        </span>
                                        <span>
                                            {{ basket.price.currencySymbol }}
                                            {{ item.price.toFixed(2) }}
                                        </span>
                                    </td>
                                    <td class="text-right">{{ item.qty }}</td>
                                    <td class="text-right">
                                        {{ basket.price.currencySymbol }}
                                        {{ item.rowprice.toFixed(2) }}
                                    </td>
                                </tr>
                            </tbody>
                            <tbody class="border-top border-1">
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td class="text-right">{{ $t("basket.table.subtotal" )}}:</td>
                                    <td class="text-right">
                                        {{ basket.price.currencySymbol }}
                                        {{ basket.price.subTotal.toFixed(2) }}
                                    </td>
                                </tr>
                            </tbody>
                            <tbody class="border-top border-1" v-if="coupons.length > 0">
                                <tr class="py-2" v-for="coupon in coupons">
                                    <td colspan="3" class="text-right">
                                        <span class="badge badge-info font-weight-normal mr-1">
                                            {{ coupon.type === "creator_code" ? $t("basket.table.creator_code") : $t("basket.table.coupon") }}
                                        </span>
                                        <span class="text-monospace pr-2">{{ coupon.code }}</span>
                                        <a href="javascript:void(0);" @click="removeCoupon(coupon.id)" v-if="coupon.type === 'coupon'">
                                            <i class="fa fa-times text-danger"></i>
                                        </a>
                                    </td>
                                    <td class="text-right">
                                        -{{ basket.price.currencySymbol }}
                                        {{ coupon.saving.toFixed(2) }}
                                    </td>
                                </tr>
                            </tbody>
                            <tbody class="border-top border-1" v-if="basket.price.tax && basket.price.tax.taxAmount > 0">
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td class="text-right">{{basket.price.tax.name}}:</td>
                                    <td class="text-right">
                                        {{ basket.price.currencySymbol }}
                                        {{ basket.price.tax.taxAmount.toFixed(2) }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <!-------------------- Subscriptions period & price -------------------
                            Hopefully this just slots straight into the new design but may need
                            some changes to the spacing.
                        ----------------------------------------------------------------------->
                        <div v-if="recurringItems.length > 0" class="py-2 basket-subscriptions">
                            <table class="table small mb-0 py-2">
                                <tr>
                                    <th class="py-0 basket-subscriptions-heading">
                                        {{ recurringItems.length > 1 ? $t('basket.subscriptions') : $t('basket.subscription') }}
                                    </th>
                                </tr>
                                <tr v-for="recurringItem in recurringItems" :key="recurringItem.id">
                                    <td v-if="recurringItem.meta.expiry_length && recurringItem.meta.expiry_period" class="py-0 basket-subscriptions-data">
                                        {{ expiryLength(recurringItem.meta.expiry_length, recurringItem.meta.expiry_period) }}
                                    </td>
                                    <td class="py-0 basket-subscriptions-data basket-subscriptions-price">
                                        {{ basket.price.currencySymbol ? basket.price.currencySymbol : store.currencySymbol }}
                                        {{ recurringItem.price }} + {{basket.price.tax.name}}
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <!--------------------------------------------------------------------->
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <table class="table mb-0">
                    <tbody>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td class="text-right pr-0">{{ paymentIntervalFirst }}:</td>
                        <td class="text-right pr-0">
                            <span class="text-lg font-weight-bold h4 text-primary">
                                {{ basket.price.currencySymbol }}
                                {{ basket.price.total.toFixed(2) }}
                                <span v-if="basket.price.currencySymbol === '$'">
                                    {{ basket.price.currencyCode ? basket.price.currencyCode : store.currency }}
                                </span></span></td>
                    </tr>
                    <tr v-if="basket.recurring">
                        <td></td>
                        <td></td>
                        <td></td>
                        <td class="text-right pr-0">{{ paymentIntervalRecurring }}:</td>
                        <td class="text-right pr-0">
                            <span class="text-lg font-weight-bold h4 text-primary">
                                {{ basket.price.currencySymbol }}
                                {{(basket.price.recurring.amount + basket.price.recurring.tax).toFixed(2) }}
                                <span v-if="basket.price.currencySymbol === '$'">
                                    {{ basket.price.currencyCode ? basket.price.currencyCode : store.currency }}
                                </span>
                            </span>
                        </td>
                    </tr>
                    </tbody>
                    <tbody v-if="giftcards.length > 0">
                    <tr v-for="giftcard in giftcards">
                        <td colspan="4" class="text-right pr-0">
                            <span class="badge badge-info font-weight-normal mr-1">
                                {{ $t("basket.table.giftcard") }}
                            </span>
                            <span class="text-monospace pr-2">{{ giftcard.giftcard }}</span>
                            <a href="javascript:void(0);" @click="removeGiftCard(giftcard.id)">
                                <i class="fa fa-times text-danger"></i>
                            </a>
                        </td>
                        <td class="text-right pr-0">
                            {{ basket.price.currencySymbol }}
                            {{ parseFloat(giftcard.deduction).toFixed(2) }}
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td class="text-right pr-0">{{ $t("basket.table.balance") }}:</td>
                        <td class="text-right pr-0">
                            <span class="text-lg font-weight-bold h4 text-primary">
                                {{ basket.price.currencySymbol }}
                                {{ basket.price.balance.toFixed(2) }}
                            </span>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="card mt-3" v-if="currencyNotSupported">
            <div class="card-body">
                {{
                    $t("basket.currency_not_supported", {
                        'converted_to': selectedPaymentMethod.currency,
                        'converted_from': basket.price.currencyCode ? basket.price.currencyCode : store.currency
                    })
                }}
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    computed: {
        ...mapState({
            selectedPaymentMethod: state => state.payment.selectedMethod,
            isPaymentMethodUpdate: state => state.basket.isPaymentMethodUpdate,
            store: state => state.app.store,
            coupons: state => state.basket.coupons,
            giftcards: state => state.basket.giftcards,
            items: state => state.basket.items,
            recurringItems: state => state.basket.recurringItems,
            basket: state => state.basket
        }),
        paymentIntervalFirst() {
            if (this.basket.recurring) {
                if (this.isPaymentMethodUpdate) {
                    return this.$t("basket.table.to_pay_next") + " " + this.basket.recurringNextPaymentDate;
                }

                return this.$t("basket.table.to_pay_today");
            }

            return this.$t("basket.table.total_price");
        },
        paymentIntervalRecurring() {
            return this.$t("basket.table.recurring_payment_interval", { interval: this.basket.recurringPeriod });
        },
        currencyNotSupported() {
            let currency = this.store.currency;

            if (this.basket.price.currencyCode !== this.store.currency) {
                currency = this.basket.price.currencyCode;
            }

            return (this.selectedPaymentMethod && this.selectedPaymentMethod.currency !== currency);
        }
    },
    methods: {
        removeCoupon(id) {
            this.$store.dispatch('removeCoupon', id).catch((error) => {
                this.$swal({ type: 'error', text: error.response.data.message });
            });
        },
        removeGiftCard(id) {
            this.$store.dispatch('removeGiftCard', id).catch((error) => {
                this.$swal({ type: 'error', text: error.response.data.message });
            });
        },
        expiryLength(length, timePeriod) {
            return this.$t('basket.expiry_length', {
                length,
                period: this.$t(`basket.time_period.${timePeriod}`)
            });
        },
    },
    name: "BasketList"
}
</script>
